var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84804 2.70581L8.49995 2.36825L8.15186 2.70581C5.48538 5.29169 4.26662 7.37803 4.26662 9.59961C4.26662 11.9376 6.16194 13.8329 8.49995 13.8329C10.838 13.8329 12.7333 11.9376 12.7333 9.59961C12.7333 7.37803 11.5145 5.29169 8.84804 2.70581ZM4.19995 9.59961C4.19995 7.24535 5.55296 5.04897 8.49995 2.28159C11.4469 5.04897 12.8 7.24535 12.8 9.59961C12.8 11.9745 10.8748 13.8996 8.49995 13.8996C6.12513 13.8996 4.19995 11.9745 4.19995 9.59961Z",
    fill: "#09090B",
    stroke: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.d8d0966be55da9524b249a1964e2d0e6.svg";
export { ForwardRef as ReactComponent };